import { convertJSDayToSystemDay } from './dateUtils';

// Últimos 30 dias: quantos dias o hábito estava "agendado" (por weekdays) vs quantos foram completados
export function getHabitConsistency(habit) {
  if (!habit || habit.active === false) return { scheduled: 0, completed: 0, rate: 0 };
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  let scheduled = 0;
  let completed = 0;
  const cdSet = new Set((habit.completedDates || []).map((d) => (typeof d === 'string' ? d.split('T')[0] : d)));
  const start = habit.startDate ? new Date(habit.startDate + 'T00:00:00') : null;
  for (let i = 0; i < 30; i++) {
    const d = new Date(today);
    d.setDate(d.getDate() - i);
    d.setHours(0, 0, 0, 0);
    if (start && d < start) continue;
    const sd = convertJSDayToSystemDay(d.getDay());
    if (habit.weekdays?.length && !habit.weekdays.includes(sd)) continue;
    scheduled++;
    const dateStr = d.toISOString().split('T')[0];
    if (cdSet.has(dateStr)) completed++;
  }
  const rate = scheduled > 0 ? completed / scheduled : 0;
  return { scheduled, completed, rate };
}

// Calcula a sequência atual de dias com hábitos completados
export function calculateCurrentStreak(habits) {
  if (!habits || habits.length === 0) return 0;

  const today = new Date();
  let currentStreak = 0;
  let date = new Date();

  // Verifica os últimos 30 dias
  for (let i = 0; i < 30; i++) {
    const dateStr = date.toISOString().split('T')[0];
    const allHabitsCompleted = habits.every(habit => {
      if (!habit.active) return true;
      return habit.completedDates?.includes(dateStr);
    });

    if (allHabitsCompleted) {
      currentStreak++;
    } else {
      break;
    }

    date.setDate(date.getDate() - 1);
  }

  return currentStreak;
}

// Calcula o número de semanas perfeitas (todos os hábitos completados)
export function calculatePerfectWeeks(habits) {
  if (!habits || habits.length === 0) return 0;

  const today = new Date();
  let perfectWeeks = 0;
  let date = new Date();
  date.setDate(date.getDate() - (date.getDay() || 7)); // Começa do último domingo

  // Verifica as últimas 12 semanas
  for (let week = 0; week < 12; week++) {
    let isPerfectWeek = true;

    // Verifica cada dia da semana
    for (let day = 0; day < 7; day++) {
      const dateStr = date.toISOString().split('T')[0];
      const allHabitsCompleted = habits.every(habit => {
        if (!habit.active) return true;
        return habit.completedDates?.includes(dateStr);
      });

      if (!allHabitsCompleted) {
        isPerfectWeek = false;
        break;
      }

      date.setDate(date.getDate() - 1);
    }

    if (isPerfectWeek) {
      perfectWeeks++;
    }
  }

  return perfectWeeks;
} 